export default {
  data () {
    return {
      dataMixinTaskFields: [
        {
          label: '',
          key: 'selected',
          sortable: false,
          tdClass: 'call-tabel--center',
          thClass: 'call-tabel--center',
          thStyle: { width: '40px' }
        },
        {
          label: '',
          key: 'isBlocked',
          tdClass: 'call-tabel-icon',
          thClass: 'call-tabel-icon'
        },
        {
          label: 'Player ID',
          key: 'player_id',
          sortable: false,
          tdClass: 'call-td call-td--grey',
          thClass: 'call-th'
        },
        {
          label: 'Task ID',
          key: 'id',
          sortable: false,
          tdClass: 'call-td call-td--grey',
          thClass: 'call-th',
          thStyle: { width: '8%' }
        },
        {
          label: 'Operator',
          key: 'operator_name',
          sortable: false,
          tdClass: 'call-td call-td--bold',
          thClass: 'call-th'
        },
        {
          label: 'Player Name',
          key: 'player_name',
          sortable: false,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        // {
        //   label: 'Birthday',
        //   key: 'player_birthday',
        //   sortable: true,
        //   tdClass: 'call-td',
        //   thClass: 'call-th'
        // },
        {
          label: 'Scheduled',
          key: 'execute_before',
          sortable: true,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: 'Gift',
          key: 'is_bonus_given',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span'
        },
        {
          label: 'auto_closed_free',
          key: 'auto_closed_free',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span'
        },
        {
          label: 'auto_closed_assigned',
          key: 'auto_closed_assigned',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span'
        },
        {
          label: 'KPI',
          key: 'kpi',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span'
        },
        {
          label: 'Auto-Call',
          key: 'auto_call_status',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span call-tabel--nowrap'
        },
        {
          label: 'Comments',
          key: 'comment_count',
          sortable: false,
          tdClass: 'call-td call-tabel--center',
          thClass: 'call-th call-tabel--center call-tabel--span'
        },
        {
          label: 'Created at',
          key: 'created_at',
          sortable: true,
          tdClass: 'call-td',
          thClass: 'call-th'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'call-tabel-action--tasks call-tabel-action',
          thClass: 'call-tabel-action--tasks',
          thStyle: { width: '12%' }
        }
      ]
    };
  },
  methods: {
    onHover (item) {
      item.actions = true;
    },
    onUnHover (item) {
      item.actions = false;
    }
  }
};
